import React, { useEffect, useRef, useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import { debounce } from 'lodash';

interface Props {
  currentRefinement: string,
  placeholder?: string,
  refine: (refinement: string) => void,
  onUpdateCallback?: (refinement: string) => void,
}

const KeywordSearch: React.FC<Props> = ({
  currentRefinement,
  placeholder,
  refine,
  onUpdateCallback,
}) => {
  const [term, setTerm] = useState(currentRefinement);

  useEffect(() => {
    if (currentRefinement !== term) {
      setTerm(currentRefinement);
    }
  }, [currentRefinement]);

  const debounceQuery = useRef(
    debounce((value) => {
      if (value.length >= 3 || value.length === 0) {
        refine(value);
        if (onUpdateCallback) {
          onUpdateCallback(value);
        }
      }
    }, 500),
  ).current;

  useEffect(() => {
    return () => {
      debounceQuery.cancel();
    };
  }, [debounceQuery]);

  useEffect(() => {
    debounceQuery(term);
  }, [term, debounceQuery]);

  return (
    <div className="ais-SearchBox">
      <form className="ais-SearchBox-form" role="search" onSubmit={(event) => event.preventDefault()}>
        <input
          className="ais-SearchBox-input ais-SearchBox-keyword-input"
          type="search"
          value={term}
          onChange={(event) => setTerm(event.currentTarget.value)}
          placeholder={placeholder || 'Search...'}
        />
      </form>
    </div>
  );
};

export default connectSearchBox(KeywordSearch);
